/* assets/nr-infinite.js — endless scroll for collection + search grids (Prestige) */
(function(){
  function init(){
    var list=document.querySelector('product-list.product-list');
    var nav=document.querySelector('nav.pagination');
    if(!list||!nav) return;
    document.documentElement.classList.add('nr-inf');
    var url=new URL(location.href);
    var page=parseInt(url.searchParams.get('page')||'1',10);
    var total=0;
    nav.querySelectorAll('a.pagination__link, .pagination__link').forEach(function(a){var n=parseInt((a.textContent||'').trim(),10); if(n>total) total=n;});
    if(!total||page>=total) return;
    var status=document.createElement('div'); status.className='nr-inf__status'; status.setAttribute('aria-live','polite');
    nav.parentNode.insertBefore(status,nav.nextSibling);
    var loading=false;
    function loadNext(){
      if(loading||page>=total) return; loading=true; status.textContent='Loading more records…';
      var next=new URL(location.href); next.searchParams.set('page',String(page+1));
      fetch(next.toString(),{credentials:'same-origin'}).then(function(r){return r.text();}).then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var nl=doc.querySelector('product-list.product-list');
        if(nl){ Array.prototype.slice.call(nl.children).forEach(function(c){ list.appendChild(document.importNode(c,true)); }); }
        page++; loading=false;
        if(page>=total){ status.textContent='That’s the lot — '+list.querySelectorAll('product-card').length+' records.'; io.disconnect(); }
        else { status.textContent=''; }
      }).catch(function(){ loading=false; status.innerHTML='<a href="'+next.toString()+'">Load more records</a>'; });
    }
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting) loadNext(); }); },{rootMargin:'900px 0px'});
    io.observe(status);
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('facet:update',function(){ setTimeout(init,300); });
})();
